import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-cinema-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">热度榜单</h2>
          <p className="text-sm text-cinema-muted">实时更新 · 全网热议影视作品排行</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group relative bg-cinema-card hover:bg-cinema-card-hover rounded-lg overflow-hidden border border-cinema-border hover:border-cinema-gold/30 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={item.coverUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-cinema-bg via-cinema-bg/20 to-transparent"></div>
                <div className="absolute top-3 left-3 w-8 h-8 rounded-md bg-cinema-gold text-cinema-bg flex items-center justify-center font-bold text-sm">
                  {item.rank}
                </div>
                <div className="absolute top-3 right-3 px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap bg-cinema-bg/80 text-cinema-gold">
                  {item.score}分
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-white group-hover:text-cinema-gold transition-colors mb-1 whitespace-nowrap overflow-hidden text-ellipsis">{item.title}</h3>
                <p className="text-xs text-cinema-muted mb-2">{item.subtitle}</p>
                <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium ${item.tagClass} whitespace-nowrap`}>
                  {item.tag}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}